import bProgress from './progress.vue';

export default bProgress;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/progress/progress.js
// module id = 420
// module chunks = 1